import React, { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { Col, Form, Row, Tabs } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import DF from 'DisplayFramework';
import GetLabel from 'DisplayFramework/components/GetLabel';
import FormInput from 'components/FormInput';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import Value from 'components/Value';
// import PFileSelectInput from 'components/PFileSelectInput';
import UtinaCard from 'components/UtinaCard';
import {
  getSuppInvoiceFileAndDetailById,
  SuppinvoiceFileDetailList,
} from 'services/supplierInvoice';
import { toCurrency, toRate } from 'utils/utils';
import MgCompanyList from 'components/MgCompanyList';
import moment from 'moment';
import ModalControllerNV from 'components/ModalControllerNV';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import ModalController from 'components/ModalController';
import ProposalModal from 'pages/ProposalV3/ProposalModal';

const { TabPane } = Tabs;
const SIFileDetail = () => {
  let { sfid } = useParams<{ sfid: string }>();

  const [suppinvoiceFileDetailList, setSuppinvoiceFileDetailList] =
    useState<any[]>();

  const { data, refetch, isFetching } = useQuery(
    ['getPayFileDetailByPfid', Number(sfid)],
    () =>
      getSuppInvoiceFileAndDetailById({ sfid: Number(sfid) }).then((res) => {
        setSuppinvoiceFileDetailList(res.data.suppinvoiceFileDetailList);
        return res.data;
      }),
    { enabled: !!sfid }
  );

  const [form] = useForm();

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data]);

  const columns = useMemo<DataGridColDef<SuppinvoiceFileDetailList>[]>(
    () => [
      {
        dataIndex: 'sfid',
        width: 80,
      },
      {
        dataIndex: 'sfdid',
        width: 80,
      },
      {
        dataIndex: 'supplierreference',
        width: 120,
        render: (value, record) => {
          return (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {data?.supplierreference}
                </a>
              )}
              modal={({ setVisible, visible }) => (
                <ThirdPartyModal
                  tpId={data?.tpidsupplier}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  onSuccess={() => setVisible(false)}
                  title={data?.suppliername ?? ''}
                  iscreate={false}
                />
              )}
            />
          );
        },
      },
      {
        dataIndex: 'suppliername',
        width: 150,
        render: (value, record) => {
          return (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {data?.suppliername}
                </a>
              )}
              modal={({ setVisible, visible }) => (
                <ThirdPartyModal
                  tpId={data?.tpidsupplier}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  onSuccess={() => setVisible(false)}
                  title={data?.suppliername ?? ''}
                  iscreate={false}
                />
              )}
            />
          );
        },
      },

      {
        dataIndex: 'tpname',
        width: 120,
        render: (value, record) => {
          return (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {value}
                </a>
              )}
              modal={({ setVisible, visible }) => (
                <ThirdPartyModal
                  tpId={record.tpidclient}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  onSuccess={() => setVisible(false)}
                  title={record.tpname}
                  iscreate={false}
                />
              )}
            />
          );
        },
      },
      {
        dataIndex: 'ctreference',
        width: 120,
        render: (value, record) => (
          <ModalController>
            {({ setVisible, visible }) => (
              <>
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {value}
                </a>
                <ProposalModal
                  ctrid={record.ctrid}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  onSuccess={() => setVisible(false)}
                  title={record.tpname}
                  iscreate={false}
                />
              </>
            )}
          </ModalController>
        ),
      },
      {
        dataIndex: 'assetreference',
        width: 150,
      },
      {
        dataIndex: 'assetlabel',
        width: 130,
      },
      {
        dataIndex: 'ctecategory',
        width: 130,
      },
      {
        dataIndex: 'ctedescription',
        width: 120,
      },
      {
        dataIndex: 'ctetype',
        width: 120,
      },

      {
        dataIndex: 'ctsstartdate',
        width: 120,
      },
      {
        dataIndex: 'ctsduedate',
        width: 120,
      },
      {
        dataIndex: 'servrepayamount',
        width: 130,
        render: (value, record) => toCurrency(value, data?.currcode),
      },
      {
        dataIndex: 'servrepaytaxcode',
        width: 120,
      },
      {
        dataIndex: 'servrepaytaxrate',
        width: 120,
        render: (value, record) => toRate(value),
      },

      {
        dataIndex: 'servrepaytaxamount',
        width: 120,
        render: (value, record) => toCurrency(value, data?.currcode),
      },
      {
        dataIndex: 'servrepaygrossamount',
        width: 120,
        render: (value, record) => toCurrency(value, data?.currcode),
      },
    ],
    [suppinvoiceFileDetailList, data]
  );

  return (
    <DF.Provider pagcode="sifiledetail">
      <Form form={form} labelAlign="left" layout="vertical">
        <div className="card-container">
          <Tabs animated defaultActiveKey="1" type="card">
            <TabPane tab={<GetLabel label="SIFileDetail" />} key="1">
              <Row gutter={40}>
                <UtinaCard
                  level={5}
                  comcode="SIFileDetail"
                  style={{ color: '#000', marginLeft: 30 }}
                  lg={17}
                >
                  <Row gutter={18}>&nbsp;</Row>
                  <Row gutter={20}>
                    <Col xs={24} lg={24}>
                      <Row gutter={30} style={{ textAlign: 'left' }}>
                        <FormInput col md={8} name="sfid">
                          <Value />
                        </FormInput>
                        <FormInput col md={8} name="mgid">
                          <MgCompanyList disabled />
                        </FormInput>

                        <FormInput col md={8} name="sfstatuslabel">
                          <Value />
                        </FormInput>
                        <FormInput col md={8} name="servlabel">
                          <Value />
                        </FormInput>

                        <FormInput col md={8} name="startdate">
                          <Value
                            formatter={(value) =>
                              moment(value).format('YYYY-MM-DD')
                            }
                          />
                        </FormInput>

                        <FormInput col md={8} name="creationdate">
                          <Value
                            formatter={(value) =>
                              moment(value).format('YYYY-MM-DD')
                            }
                          />
                        </FormInput>
                        <FormInput col md={8} name="sftotallines">
                          <Value />
                        </FormInput>

                        <FormInput col md={8} name="supplierreference">
                          <ModalControllerNV
                            content={({ setVisible, visible }) => (
                              <a
                                onClick={() => {
                                  setVisible(true);
                                }}
                              >
                                {form.getFieldValue('supplierreference')}
                              </a>
                            )}
                            modal={({ setVisible, visible }) => (
                              <ThirdPartyModal
                                tpId={data?.tpidsupplier}
                                visible={visible}
                                onCancel={() => setVisible(false)}
                                onSuccess={() => setVisible(false)}
                                title={data?.suppliername ?? ''}
                                iscreate={false}
                              />
                            )}
                          />
                        </FormInput>

                        <FormInput col md={8} name="cipaystatus">
                          <Value />
                        </FormInput>

                        <FormInput col md={8} name="jobid">
                          <Value />
                        </FormInput>
                      </Row>
                    </Col>
                  </Row>
                </UtinaCard>
                <UtinaCard
                  level={5}
                  comcode="FinancialInfo"
                  style={{ color: '#000', marginLeft: 30 }}
                  lg={6}
                >
                  <Row gutter={18}>&nbsp;</Row>
                  <Row gutter={20}>
                    <Col xs={24} lg={24}>
                      <Row gutter={30} style={{ textAlign: 'left' }}>
                        <FormInput col md={12} name="sftotalnetamount">
                          <Value
                            formatter={(value) =>
                              toCurrency(value, form.getFieldValue('currcode'))
                            }
                          />
                        </FormInput>
                        <FormInput col md={12} name="sftotaltaxamount">
                          <Value
                            formatter={(value) =>
                              toCurrency(value, form.getFieldValue('currcode'))
                            }
                          />
                        </FormInput>
                        <FormInput col md={12} name="sftotalgrossamount">
                          <Value
                            formatter={(value) =>
                              toCurrency(value, form.getFieldValue('currcode'))
                            }
                          />
                        </FormInput>
                        <FormInput col md={12} name="currcode">
                          <Value />
                        </FormInput>

                        <FormInput col md={12} name="taxcode">
                          <Value />
                        </FormInput>
                        {/* 
                          <PFileSelectInput /> */}
                      </Row>
                    </Col>
                  </Row>
                </UtinaCard>
              </Row>

              <Row gutter={16}></Row>
            </TabPane>

            <TabPane tab={<GetLabel label="SIFileDetailList" />} key="2">
              <DataGrid
                rowKey="payid"
                dataSource={suppinvoiceFileDetailList}
                titleComcode="SIFileDetailList"
                hideFilters
                columns={columns}
                isLoading={isFetching}
              />
            </TabPane>
          </Tabs>
        </div>
      </Form>
    </DF.Provider>
  );
};

export default SIFileDetail;
